// src/pages/Success.jsx
import React from 'react';

const Success = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50">
      <div className="p-8 bg-white rounded shadow-md text-center">
        <h1 className="text-3xl font-bold text-green-700 mb-4">Payment Successful!</h1>
        <p className="text-gray-700">Your subscription is now active.</p>
      </div>
    </div>
  );
};

export default Success;
